module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-active-32.0cd46e21.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-active-32.png
// module id = 3172
// module chunks = 11